import { ComponentPropsWithoutRef } from 'react';
import { Typography } from '../../../ui';

export function I(props: ComponentPropsWithoutRef<'i'>) {
  const { children, ...rest } = props;

  return (
    <Typography as="i" weight="regular" {...rest}>
      {children}
    </Typography>
  );
}
